/**
 * Placeholder for undefined function
 */
const noop = () => undefined;

export default noop;
